// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"47":"pricing","383":"question","388":"result","962":"home"}[chunkId] || chunkId) + "." + {"47":"ac6dde85","108":"cb88681b","383":"c7f1556a","388":"42a9694d","570":"b793795b","846":"647740db","962":"fadb785a"}[chunkId] + ".css";
};